import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {VideoGridElement} from '../../_shared/videos-grid/video-grid-element.model';

@Component({
    selector: 'app-DeathOfAnOwner',
    templateUrl: './DeathOfAnOwner.component.html',
    styleUrls: ['./DeathOfAnOwner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeathOfAnOwnerComponent {

  videos: VideoGridElement[] = [
    {
      url: 'https://www.youtube.com/embed/fb4g6JcGWuc?list=PL99qj8Q3_1psopvHemZMeUntqzEw7-m5a',
      title: 'Presentation 2: Proposition 19 & Death of a Property Owner',
      powerpoint: null
    }

  ];

  constructor() { }
}
